import { ENABLE_UAEPASS } from '@/core/constants/appConfig';
import { logger } from '@/core/logger';
import { trackDynatraceEvent } from '@/core/services/dynatraceService';
import { router } from 'expo-router';

type CheckPasscodeState = () => Promise<boolean>;

export async function handleWelcomeWebLoginPress(
  checkPasscodeState: CheckPasscodeState,
  openLoginDialog: () => void,
): Promise<void> {
  trackDynatraceEvent({
    p_screen: 'welcome',
    p_actionName: 'User Login Started',
    eventType: 'action',
  });
  if (!ENABLE_UAEPASS) {
    logger.info('WelcomeWeb:UAE Pass disabled, opening login dialog');
    openLoginDialog();
    return;
  }

  try {
    const passcodeSet = await checkPasscodeState();
    if (passcodeSet) {
      logger.info('WelcomeWeb:Passcode set, navigating to passcode-login');
      router.push('/passcode-login' as never);
      return;
    }
    logger.info('WelcomeWeb:No passcode set, opening login dialog');
    openLoginDialog();
  } catch (error) {
    logger.error('WelcomeWeb:Failed to check passcode state', { error });
    openLoginDialog();
  }
}
